import moment, { Moment } from 'moment';
import { CZECH_HOLIDAYS } from 'skladon-types';
import { isCzechEaster } from './functions';

export type RequiredExpeditionDateValueType = string | Date | Moment | null | undefined;

export const REQUIRED_EXPEDITION_DATE_EDITABLE_STATUSES = [
    'preReceived',
    'waitingForPayment',
    'waitingForShipment',
    'productsNotAvailable',
    'incorrect',
    'suspended',
];

export function isRequiredExpeditionDateEditable(
    status: string | null | undefined,
    disableEdit: boolean,
    summary: boolean
): boolean {
    return REQUIRED_EXPEDITION_DATE_EDITABLE_STATUSES.includes(status || 'preReceived') && !disableEdit && !summary;
}

const toDay = (value: RequiredExpeditionDateValueType): string => (value ? moment(value).format('YYYY-MM-DD') : '');

export function isRequiredExpeditionDateChanged(
    original: RequiredExpeditionDateValueType,
    current: RequiredExpeditionDateValueType
): boolean {
    return toDay(original) !== toDay(current);
}

export function isRequiredExpeditionDateDisabledDay(date: Date | Moment | string): boolean {
    return (
        moment(date).isoWeekday() === 6 ||
        moment(date).isoWeekday() === 7 ||
        CZECH_HOLIDAYS.includes(moment(date).format('D.M')) ||
        isCzechEaster(date)
    );
}

export function getRequiredExpeditionMinDate(now: Moment): Moment {
    return moment(now).add(2, 'days').startOf('day');
}

/**
 * Returns true when the value is invalid. Validation applies only to an editable field
 * with a non-empty value that differs (by day) from the originally stored one.
 */
export function getRequiredExpeditionDateError(
    value: RequiredExpeditionDateValueType,
    original: RequiredExpeditionDateValueType,
    { editable, now }: { editable: boolean; now: Moment }
): boolean {
    if (!editable || !value) {
        return false;
    }
    const date = moment(value);
    if (!date.isValid()) {
        return true;
    }
    if (!isRequiredExpeditionDateChanged(original, value)) {
        return false;
    }
    return date.isBefore(getRequiredExpeditionMinDate(now)) || isRequiredExpeditionDateDisabledDay(date);
}
